/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NavigationCreate } from '../models/NavigationCreate'
import type { NavigationResource } from '../models/NavigationResource'
import type { NavigationWrite } from '../models/NavigationWrite'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class NavigationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getAllNavigation({
        url,
        page,
        location
    }: {
        /**
         * Filter by URL.
         */
        url?: string
        /**
         * Filter by page.
         */
        page?: string
        /**
         * Filter by location.
         */
        location?: string
    }): CancelablePromise<{
        data: Array<NavigationResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/navigation',
            query: {
                url: url,
                page: page,
                location: location
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any Created
     * @throws ApiError
     */
    public createNavigation({ requestBody }: { requestBody?: NavigationCreate }): CancelablePromise<{
        data: NavigationResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/navigation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNavigation({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: NavigationResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/navigation/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public deleteNavigation({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/navigation/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateNavigation({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody?: NavigationWrite
    }): CancelablePromise<{
        data: NavigationResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/navigation/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
